import React, { useState } from "react";
import {
  Link,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import EditIcon from "../../../assets/svg/edit-icon.svg"
import DeleteIcon from "../../../assets/svg/delete-icon.svg"

export default function ShippingPartnerActions({row, setEditRecord, setDeleteConfirmOpen, setDeleteRecord}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Link
        component="button"
        underline="none"
        color="primary"
        onClick={handleClick}
      >
        VIEW
      </Link>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          elevation: 3,
          sx: {
            minWidth: 200,
            borderRadius: 2,
            mt: 1,
          },
        }}
      >
        <MenuItem onClick={()=>{
          setEditRecord(row)
        }}>
          <ListItemIcon>
           <img src={EditIcon} alt="" />
          </ListItemIcon>
          <ListItemText primary={'Edit'} />
        </MenuItem>

        <MenuItem onClick={()=>{
          setDeleteRecord(row)
          setDeleteConfirmOpen(true);
        }}>
          <ListItemIcon>
            <img src={DeleteIcon} alt="" />
          </ListItemIcon>
          <ListItemText  primary="Delete" />
        </MenuItem>
      </Menu>
    </>
  );
}
